import axios from '../api/axios';

export async function getEquipments(options) {
  const res = await axios.get(`/vehicleEquipments`, options);

  return res.data;
}

export async function getEquipmentsByGeneration(vehicleGenerationId) {
  const res = await axios.get(
    `/vehicleGenerations/${vehicleGenerationId}/vehicleEquipments`
  );

  return res.data;
}

export async function createEquipment(body) {
  console.log(body);
  const response = await axios.post(
    '/vehicleEquipments',
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function updateEquipment(equipmentId, body) {
  const response = await axios.patch(
    `/vehicleEquipments/${equipmentId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function deleteEquipment(equipmentId) {
  const response = await axios.delete(`/vehicleEquipments/${equipmentId}`);
  return response;
}
